import React, { useState } from 'react';
import BusinessStyles from './AddTestimonial.module.css';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { fetchNotifications } from '../../state/GlobalState'

const AddTestimonial = () => {
  
  const location = useLocation();
  const data = location.state;
  console.log(data);

  const navigate = useNavigate();

  // Notification section start
  // Get data from redux
  const name=useSelector((state)=>state.globalData.name);
  const count=useSelector((state)=>state.globalData.notificationCount);
  const dispatch =  useDispatch()

  const [businessData, setBusinessData] = useState({
    testimonialName: '',
    testimonialPosition: '',
    testimonialMessage: '',
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setBusinessData({ ...businessData, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const businessResponse = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/testimonial/addTestimonial`,
        businessData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      // console.log('Testimonial Added.');
      // console.log(businessResponse);

      dispatch(fetchNotifications())

           dispatch(setNotificationCount({
            count:count+1,
           }))
      alert('Testimonial Added.');
      navigate('/testimonial');
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={BusinessStyles.businessMain}>
      <div className={BusinessStyles.businessContent}>
        <form
          action=""
          className={BusinessStyles.businessForm}
          onSubmit={handleSubmit}
        >
          <label className={BusinessStyles.businessFormLabel}>Name</label>
          <input
            className={BusinessStyles.businessFormText}
            type="text"
            value={businessData.testimonialName}
            name="testimonialName"
            onChange={handleInputChange}
          />
          <label className={BusinessStyles.businessFormLabel}>Position</label>
          <input
            className={BusinessStyles.businessFormText}
            type="text"
            value={businessData.testimonialPosition}
            name="testimonialPosition"
            onChange={handleInputChange}
          />
          <label className={BusinessStyles.businessFormLabel}>Message</label>
          <textarea
            className={BusinessStyles.businessFormDesc}
            value={businessData.testimonialMessage}
            name="testimonialMessage"
            onChange={handleInputChange}
          />
          <Button variant="contained" type="submit" className={BusinessStyles.saveChanges}>
            Save changes
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AddTestimonial;
